import { render, staticRenderFns } from "./ProfitAndLossProjectionChart.vue?vue&type=template&id=ffe558d2"
import script from "./ProfitAndLossProjectionChart.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossProjectionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports